import Meta from "../../../components/common/Meta";
import React, {useEffect} from "react";
import ErrorContent from "../../../components/common/error/ErrorContent";
import MainDesign from "../../MainDesign";
import {TraceService} from "../../../service/TraceService";
import {TraceType} from "../../../model/user/general/Trace";
import {v4 as uuidv4} from "uuid";
import EnProdukacjaCopyrightNote from "../../../components/funnel/EnProdukacjaCopyrightNote";

export default function Error404() {
    useEffect(() => {
        const sessionId = localStorage.getItem('sessionId');
        if (!sessionId) {
            localStorage.setItem('sessionId', uuidv4());
        }
        TraceService.addTrace(TraceType.ErrorPage, undefined);
    }, []);

    return <>
        <Meta title='Page not found' noIndex={true}/>
        <MainDesign containerStyles="container py-16" useGradientBackground={true} minHeight="100vh">
            <ErrorContent messageProps="Page not found."/>
            <EnProdukacjaCopyrightNote/>
        </MainDesign>
    </>;
}
